import { StrictMode } from 'react';

import { ThemeProvider } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter } from 'react-router';
import { ToastContainer } from 'react-toastify';

import App from '@/App';
import { oidcConfig } from '@/auth';
import { ErrorBoundary } from '@/components';
import { BusinessDataProvider } from '@/providers';
import CUCTheme from '@/styles/theme';

const rootElement = document.getElementById(import.meta.env.VITE_APP_ROOT_ELEMENT_ID ?? 'root');
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(rootElement!).render(
  <StrictMode>
    <ThemeProvider theme={CUCTheme}>
      <AuthProvider {...oidcConfig}>
        <BusinessDataProvider>
          <BrowserRouter>
            <QueryClientProvider client={queryClient}>
              <ErrorBoundary>
                <App />
                <ToastContainer position="bottom-right" pauseOnHover hideProgressBar />

                <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
              </ErrorBoundary>
            </QueryClientProvider>
          </BrowserRouter>
        </BusinessDataProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
